import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpUtils } from '../../../../../common/http/http-utils';
import { NetworkConstants } from './network-constants';

@Injectable()
export class NetworkService {
  public networks;
  private networksLoaded: boolean = false;
  private url: string = HttpUtils.getBaseUrl() + '/hybridity/api/networks';
  private singularNetworkUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/networks';
  private computeUrl: string = HttpUtils.getBaseUrl() + '/hybridity/api/compute';
  private vcList;
  private backingList;
  public autoRefreshNetworks: any = {allow: false, attempt: 0, maxAllowedAttempts: 5};

  constructor(public http: HttpClient) {

  }

  getAllNetworks(context = null) {
      this.autoRefreshNetworks.allow = false;
      // do silent refresh in case of auto refresh.
      if (!context || (context && context !== 'autoRefresh')) {
          this.networksLoaded = false;
      }
    let body: any = {};
    body.filter = {
        ownedBySystem : false
    };
    let queryUrl = this.url + '?action=query';
    return this.http.post( queryUrl, body )
                    .map( this.extractNetworks ).subscribe(
            networks => {
                this.networks = [].concat(networks);
                this.networksLoaded = true;
                const nwNotReady = this.networks.find((nw) => nw.state.indexOf('IN_PROGRESS') !== -1);
                // If any network state is in_progress or no. of attempt is less than max allowed attempts
                // then trigger auto refresh of networks.max attempts cap is necessary to avoid scenarios where
                // job stuck in same state due to some reason.In that case we don't want auto refresh to happen
                // indefinitely as it will hinder user interaction with ui.
                if (nwNotReady && this.autoRefreshNetworks.attempt <= this.autoRefreshNetworks.maxAllowedAttempts) {
                    this.autoRefreshNetworks.allow = this.autoRefreshNetworks.allow || true;
                    this.autoRefreshNetworks.attempt += 1;
                    // trigger auto refresh in progressive intervals of 0.5s, 1s, 1.5s, 2s, 2.5s
                    setTimeout(() => {
                        this.getAllNetworks('autoRefresh');
                    }, 500 * this.autoRefreshNetworks.attempt);
                }
            },
            error => this.logError(error, 'get all networks'),
            () => this.logOperationCompleted('get all networks')
        );
  }

  createNetwork(network) {
    if (network && network.scope && network.scope.length === 0) {
        delete network.scope;
    }
    return this.http.post( this.url, network ).map(this.extractData );
  }

  deleteNetwork( networkId ) {
    let deleteUrl = this.singularNetworkUrl + '/' + networkId;
    return this.http.delete( deleteUrl )
                    .map( this.extractData );
  }

  getNetwork( networkId ) {
    let getUrl = this.singularNetworkUrl + '/' + networkId;
    return this.http.get( getUrl )
                    .map( this.extractData );
  }

  updateNetwork(network) {
    let putUrl = this.singularNetworkUrl + '/' + network.objectId;
    return this.http.put(putUrl, network)
                    .map(this.extractData);
  }

  getComputeContainer() {
     return this.http.get( this.computeUrl )
                    .map( this.extractData );
  }

  getPermissions(networkId){
    let getPermissionsUrl = this.singularNetworkUrl + '/' + networkId + '/permissions';
    return this.http.get(getPermissionsUrl)
                    .map(this.extractData);
  }

  getAllNetworksByScope(scopeId?: string) {
      let scopedNetworkUrl: string;
      if(scopeId) {
          scopedNetworkUrl  = this.computeUrl + '/' + scopeId + '/networks';
      } else {
          scopedNetworkUrl = this.url;
      }

      return this.http.get( scopedNetworkUrl )
                    .map( this.extractNetworks );
  }

  getAllNetworksByTrunk(scopeId?: string) {
    let url: string = HttpUtils.getBaseUrl() + '/hybridity/api/networks?action=query';
    let body = {
               "filter": {
                        "allowTrunkInterfaces": true,
                        "scopeId": scopeId
                    }
                }
    return this.http.post(url, body).map(this.extractData );
  }


  private extractData( res: Response ) {
    let body = res;
    return body;
  }

  private extractNetworks(res: any[]){
    let networks: Array<any> = res;
    for (let i = 0; i < networks.length;  ++i){
      let network = networks[i];
      if (!network.scope) {
          network.scope = [];
      }
    }
    return networks;
  }

  private logError(error, origin: String = '') {
        console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  private logOperationCompleted(msg: string) {
        console.log('Operation Completed: ', msg);
  }


    private isNetworkStateInProgress(network): boolean{
        if (network.state === NetworkConstants.STATE.IN_PROGRESS
            || network.state === NetworkConstants.STATE.CREATE_IN_PROGRESS
            || network.state === NetworkConstants.STATE.DELETE_IN_PROGRESS ){
                return true;
        }
        return false;
    }

    getVcList() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/vc/query?entityType=vcenter')
            .map(res => this.vcList = res);
    }

    getNetworkBackings (vcId: string = '') {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/admin/hybridity/api/compute/'+ vcId+'/networkBackings?filter=unused&backingType=all')
            .map(res => this.backingList = res);
    }

    createNetworkAdmin(network) {
        if (network && network.scope && network.scope.length === 0) {
            delete network.scope;
        }
        let url: string = HttpUtils.getBaseUrl() + '/admin/hybridity/api/networks';
        return this.http.post(url, network).map(this.extractData );
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/networking/networking-vc/networks/network.service.ts